module.exports = __webpack_public_path__ + "static/media/check-circle.76c7050c.svg";